import startCase from 'lodash/startCase.js';
import PendoIcon from '../../icon/pendo-icon.vue.js';
import PendoMultiselect from '../../multiselect/pendo-multiselect.vue.js';
import PendoGuideStatusOption from '../../multiselect/option-types/pendo-guide-status-option.vue.js';
import PendoGuideStatusTrigger from '../../multiselect/trigger-types/pendo-guide-status-trigger.vue.js';

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
var script = {
  name: 'PendoGuideStatusCell',
  components: {
    PendoIcon,
    PendoMultiselect,
    PendoGuideStatusTrigger,
    PendoGuideStatusOption
  },
  inject: ['$table'],
  props: {
    row: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      default: () => [{
        label: 'Public',
        state: 'public'
      }, {
        label: 'Staged',
        state: 'staged'
      }, {
        label: 'Draft',
        state: 'draft'
      }, {
        label: 'Disabled',
        state: 'disabled'
      }]
    },
    interactive: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    status() {
      return {
        state: this.row.state,
        label: startCase(this.row.state)
      };
    },
    statusColor() {
      return {
        'public': '#00aa62',
        'scheduled': '#f05b00',
        'staged': '#b08300',
        'draft': '#07699b',
        'pending-review': '#53afff',
        'disabled': '#6a6c75',
        'archived': '#6a6c75'
      }[this.row.state];
    },
    clickListener() {
      if (this.interactive) {
        return 'click';
      }
      return null;
    },
    triggerClass() {
      return ['pendo-multiselect__trigger', 'pendo-multiselect__trigger--mini', 'pendo-multiselect__trigger--outline', 'pendo-multiselect__trigger--status', `pendo-multiselect__trigger--${this.status.state}`, {
        'pendo-multiselect__trigger--fill': this.status.state === 'public'
      }];
    }
  },
  watch: {
    '$table.scrollStore.scrollActive': function (value) {
      if (value) {
        this.isOpen = false;
      }
    }
  },
  methods: {
    handleSelect(_ref) {
      let {
        state
      } = _ref;
      this.$emit('status-change', {
        row: this.row,
        value: state
      });
    },
    toggleMultiselect: _async(function () {
      const _this = this;
      if (!_this.interactive) {
        return;
      }
      _this.isOpen = true;
      return _await(_this.$nextTick(), function () {
        if (_this.$refs.guideStatus) {
          _this.$refs.guideStatus.toggleMenu();
        }
      });
    })
  }
};

export { script as default };
//# sourceMappingURL=pendo-guide-status-cell.vue2.js.map
